<template>
  <section>
    <div class="documentRow">
      <div
        class="document"
        style="cursor: pointer"
        @click="toggleIsAddingFolder"
      >
        <img class="documentIcon" src="@/assets/Upload/addFolder.svg" />
        <p>Add Notebook</p>
      </div>
      <div class="document" v-if="isAddingFolder">
        <img class="documentIcon" src="@/assets/Upload/addFolder.svg" />
        <div class="exit" @click="setIsAddingFolder">+</div>
        <input
          v-model="title"
          @keydown.enter.exact.prevent
          @keyup.enter.exact="addFolder"
        />
        <select v-model="color">
          <option :value="null" disabled>Color of folder</option>
          <option value="green">Green</option>
          <option value="red">Red</option>
          <option value="blue">Blue</option>
          <option value="orange">Orange</option>
        </select>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import db from "@/db";
import moment from "moment";

export default {
  data: () => ({
    title: "",
    color: "",
  }),

  computed: {
    ...mapState("upload", ["isAddingFolder"]),
    ...mapState("messageBoard", ["groupId"]),
  },

  methods: {
    addFolder() {
      if (this.title == "" || this.color == "") {
        return;
      }
      var notebook = {
        title: this.title,
        documents: 0,
        chat_id: this.groupId,
        createDate: moment().valueOf(),
        color: this.color,
      };
      db.collection("notebooks")
        .doc()
        .set(notebook);
      this.resetData();
    },
    resetData() {
      this.title = "";
      this.$store.commit("upload/setIsAddingFolder", false);
    },
    toggleIsAddingFolder() {
      this.$store.commit("upload/setIsAddingFolder", true);
    },
    setIsAddingFolder() {
      this.$store.commit("upload/setIsAddingFolder", false);
    },
  },
};
</script>

<style scoped>
p {
  color: gray;
  font-size: 15px;
}
input {
  border-radius: 5px;
  border: 1px solid black;
}
.document {
  display: flex;
  width: 150px;
  flex-direction: column;
  text-align: center;
  margin: 15px;
}
.documentIcon {
  height: 200px;
  width: 150px;
}
.exit {
  position: absolute;
  margin-right: 120px;
  font-size: 25px;
  background-color: #084d49;
  width: 38px;
  transform: rotate(45deg);
  align-self: center;
  border-radius: 20vw;
  color: white;
  cursor: pointer;
}
</style>
